module.exports = __webpack_public_path__ + "img/ios-hand.a888e451.svg";